/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { DocRequest } from '../types/Doc';
import type { DocResponse } from '../types/Doc';

export type DocsCreateRequest = DocRequest;
export type DocsCreateResponse = DocResponse;

export type DocsCreateQuery = {};

/**
 * POST /dmx-server/docs/
 *
 * ```yaml
 * operationId: docs_create
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/Doc'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/Doc'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/Doc'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/Doc'
 *     description: ''
 * ```
 */
export const docsCreateOperation = (rest?: DocsCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/docs/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/docs/' };
  };

/**
 * POST /dmx-server/docs/
 *
 * ```yaml
 * operationId: docs_create
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/Doc'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/Doc'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/Doc'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/Doc'
 *     description: ''
 * ```
 */
export const docsCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: DocsCreateQuery;
  request: DocRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DocResponse>> => {
  const operation = docsCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
